import cn from '@/lib/cs';
import React from 'react';

const ExpandIcon = ({ className, ...props }: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		aria-hidden
		className={cn('h-8 lg:h-12 pointer-events-none', className)}
		{...props}
	>
		<path
			fill="currentColor"
			d="M23.84 7.12c-.1 1.33-.2 2.58-.09 3.3l.04.22-.17.14c-.5.4-.93.52-1.3.52-.29 0-.52-.09-.7-.21-1.2-.76-1.48-3.46-1.43-5.27-1.05 1.31-2.52 2.9-3.57 3.5l-1.9 1.47-.1.07h-1.94l.05-.4v-.5c-.02-.43-.04-.87.1-1.16A28.32 28.32 0 0 1 17 3.5l-.35.02c-1.65.15-3.71.33-4.37-.64-.3-.45-.26-1.04.1-1.76l.06-.13.14-.05c2.8-1 6.34-.95 9.18-.94.57.01 1.04.22 1.4.6 1.1 1.22.86 4.04.67 6.51v.01ZM12.8 22.47v.22l-.19.1c-.9.5-5.01 1.21-8.22 1.21-1.44 0-2.69-.13-3.4-.5-.42-.21-.65-.5-.7-.85-.37-1.76-.3-3.39-.23-4.96a26 26 0 0 0-.02-3.68v-.07l.02-.07c.15-.44.43-.82.7-1.18.17-.22.34-.43.46-.64l.18-.32 1.15.7c1.7.78 1.49 2.9 1.34 4.61l-.05.42a47.27 47.27 0 0 1 4.64-4.4c.32-.22.8-.19 1.25-.17.2.01.37.02.48.01l.41-.06v2.52l-.12.1c-.19.18-2.64 3.02-3.83 4.38l-.45.52c.41-.02.87-.07 1.35-.13 1.63-.19 3.48-.4 4.5.5.46.4.7.98.72 1.74Z"
		/>
	</svg>
);

export default ExpandIcon;
